import React from 'react';
import { observer } from 'mobx-react-lite';
import { Autocomplete, Button, Icon, Typography } from '@ann/web-components';
import { DocumentsToShareContainer, DocumentsToShareItem, AutocompleteContainer } from '../Modal.styled';

const AssignModalContent = observer(({
    itemsToAssign = [],
    selectedAgents,
    onAgentsChange,
    onGiveAccess,
    suggestions = []
}) => {
    return (
        <>
            <DocumentsToShareContainer>
                {itemsToAssign.map((item, index) => (
                    <DocumentsToShareItem key={index}>
                        <Icon name="description" size="small" />
                        <Typography
                            category="body"
                            size="medium"
                            weight="regular"
                            color="body"
                            maxCharacters={30}
                        >
                            {item.name}
                        </Typography>
                    </DocumentsToShareItem>
                ))}
            </DocumentsToShareContainer>
            <AutocompleteContainer>
                <Autocomplete
                    label="Add agents"
                    placeholder="Search agents"
                    onSelectionChange={onAgentsChange}
                    selectedValues={selectedAgents}
                    multiple={true}
                    onSearch={() => { }}
                    onSuggestionSelect={() => { }}
                    suggestions={suggestions}
                    valueKey="uuid"
                    labelKey="name"
                    showInitialName
                />
                <Button
                    label="Give access"
                    size="medium"
                    type="primary"
                    onClick={onGiveAccess}
                    disabled={selectedAgents.length === 0}
                />
            </AutocompleteContainer>
        </>
    );
});

export default AssignModalContent;
